<script setup lang="ts">
import { ToastProvider, ToastViewport } from "reka-ui";

const { activeToasts, addToast } = useToast();
onMounted(() => {
  const parsedToasts = v.safeParse(v.array(toastSchema), toasts);
  if (parsedToasts.success) {
    parsedToasts.output.forEach(addToast);
  }
});
</script>

<template>
  <ToastProvider>
    <UiToast v-for="toast in activeToasts" :key="toast.id" ref="refToasts" :toast="toast" />
    <ToastViewport class="fixed left-4 top-4 z-toast flex w-[calc(100%-2rem)] max-w-[100vw] flex-col gap-3 sm:w-96" />
  </ToastProvider>
</template>
